import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { PacientService } from "src/services/pacient.service";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { AlergiasService } from "src/services/alergias.service";
import * as moment from "moment";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";

@Component({
  selector: "time-line-alergia-component",
  templateUrl: "time-line-alergia-component.html",
  styleUrls: ["./time-line-alergia-component.scss"],
})
export class TimeLineAlergiaComponent implements OnInit {
  listAlergias: any = [];
  listAlergiasFiltered: any = [];
  dtFim: any;
  dtInicio: any;
  conteudoRevelado = false;
  listaFiltroAgente: any[] = [];
  listaFiltroClasse: any[] = [];
  filtrosSelecionados: any[] = [];
  classeAlergiasList = {
    "Outra Alergia Medicamentosa": "Medicamentosa",
    "Outra Alergia Alimentar": "Alimentar",
    "Outra Alergia": "Animal",
  };

  emptyState = {
    imgUrl: "/assets/imgs/bg-alergias.svg",
    title: "O paciente não possui alergias cadastradas.",
    text: "Essa área é dedicada a registros de alergias. No momento, não há nenhuma cadastrada.",
  };
  emptyStateFilter = {
    imgUrl: "/assets/imgs/bg-alergias.svg",
    title:
      "O paciente não possui alergias cadastradas de acordo com filtros aplicados.",
    text: "Essa área é dedicada a registros de alergias. No momento, não há nenhuma cadastrada de acordo com filtros aplicados.",
  };

  constructor(
    private pacient: PacientService,
    private loadingCtrl: LoadingController,
    private alergiaService: AlergiasService,
    private toastController: ToastController,
    private modalCtrl: ModalController
  ) { }

  async ngOnInit() {
    await this.loadAlergias();

    this.listaFiltroAgente = this.listAlergias.map((al) => al.outra);

    this.listAlergias.map((al) => {
      if (!this.listaFiltroClasse.includes(this.classeAlergiasList[al.nome])) {
        this.listaFiltroClasse.push(this.classeAlergiasList[al.nome]);
      }
    });

    this.listaFiltroClasse.sort()
  }

  ordem(lista) {
    console.log('======lista', lista);
    return lista.sort((a, b) => {
      return a.nome < b.nome ? -1 : a.nome > b.nome ? 1 : 0;
    })
  }

  async loadAlergias() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    try {
      this.listAlergias = await this.alergiaService.recuperarMinhasAlergias();
      this.formatarConteudo(false);
    } catch (e) {
      console.error("error", e);
    }
    await loading.dismiss();
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  formatarConteudo(hidden: boolean) {
    this.listAlergiasFiltered = [
      {
        tipo: "ALERGIAS",
        nome: "Medicamentos",
        tipoAlergia: "Medicamentos",
        listaAlergia: [],
        dtAtualizacao: "-",
      },
      {
        tipo: "ALERGIAS",
        nome: "Alimentar",
        tipoAlergia: "Alimentar",
        listaAlergia: [],
        dtAtualizacao: "-",
      },
      {
        tipo: "ALERGIAS",
        nome: "Animais",
        tipoAlergia: "Animal",
        listaAlergia: [],
        dtAtualizacao: "-",
      },
    ];
    for (let alergia of this.listAlergias) {
      if (alergia.nome === "Outra Alergia") {
        this.listAlergiasFiltered[2].listaAlergia.push(alergia);
      }
      if (alergia.nome === "Outra Alergia Alimentar") {
        this.listAlergiasFiltered[1].listaAlergia.push(alergia);
      }
      if (alergia.nome === "Outra Alergia Medicamentosa") {
        this.listAlergiasFiltered[0].listaAlergia.push(alergia);
      }
    }
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.listAlergiasFiltered = this.listAlergiasFiltered.filter(
        (atendimento) => {
          const dtAtendimento = moment(atendimento.dtAtualizacao, "YYYY-MM-DD");
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
      );
      console.log(this.listAlergiasFiltered);
    }

    if (this.filtrosSelecionados.length) {
      const classesSelecionadas = this.filtrosSelecionados
        .filter((f) => f.tipo === "classe")
        .map((f) => f.data);
      const agentesSelecionados = this.filtrosSelecionados
        .filter((f) => f.tipo === "agente")
        .map((f) => f.data);

      this.listAlergiasFiltered = this.listAlergiasFiltered.filter((filter) => {
        let count = 0;
        if (classesSelecionadas.length) {
          if (classesSelecionadas.includes(filter.tipoAlergia)) {
            count += 1;
          }
        }
        if (agentesSelecionados) {
          filter.listaAlergia.forEach((al) => {
            if (agentesSelecionados.includes(al.outra)) {
              count += 1;
            }
          });
        }
        return !!count;
      });
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    const filtro = {
      tipo,
      data,
    };

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter();
  }
}
